import { Avatar, Box, makeStyles, Typography } from '@material-ui/core';
import React from 'react';
import { convertADtoBEYear, getThaiMonth } from '../../services/localization';
import moment from 'moment';

interface IProps {
  data: ITopicDiscussion;
}

const useStyles = makeStyles({
  content: {
    overflowWrap: 'anywhere',
  },
});
const Content: React.FC<IProps> = ({ data }) => {
  const { content } = useStyles();
  const getTimeText = (date: moment.Moment) => {
    const day = date.day();
    const month = getThaiMonth(date.month());
    const year = convertADtoBEYear(date.year());
    const time = date.format('hh:mm');
    return `วันที่ ${day} ${month} ${year} เวลา ${time}`;
  };
  return (
    <Box p={2} display='flex'>
      <Box mr={2}>
        <Avatar src={data.avatar} />
      </Box>
      <Box>
        <Box mb={1}>
          <Typography variant='caption'>
            <Box
              component='span'
              color={'#81E6D9'}
              style={{ opacity: data.author ? 1 : 0.5 }}
            >
              {data.author ? data.author : 'ไม่มีชื่อ'}&nbsp;(
              {data.uid.substring(0, 5)}xxx)
            </Box>
          </Typography>
        </Box>
        <Typography variant='body1' className={content}>
          {data.content}&nbsp;
        </Typography>
        <Box my={1}>
          <Typography variant='caption'>
            <Box component='span' style={{ opacity: 0.7 }}>
              {getTimeText(data.createdAt)}
            </Box>
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Content;
